import React from "react";
import Account from "../../common/account";
import { getEmployeeProfile, updateEmployeeProfile } from "../../../services/employee.service";

interface Props {
  employeeId: string;
}

const EmployeeAccount: React.FC<Props> = ({ employeeId }) => {
  return (
    <Account
      userId={employeeId}
      getProfile={getEmployeeProfile}
      updateProfile={updateEmployeeProfile}
      title="Your Profile"
      subtitle="Keep your details up to date"
    />
  );
};

export default EmployeeAccount;
